module.exports = __webpack_public_path__ + "img/florian-kowol-old.df628e9b.jpg";